import { Divider, Drawer, Stack } from '@mui/material';
import { CustomButton } from 'components/Button';
import Typography from 'components/Typography';
import React from 'react';
import styled from 'styled-components';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import assetDoc from 'Assets/doc/Asset_Vehicle Import Template - Sheet1.csv';
import { Box } from '@material-ui/core';
import { generateCSV } from './helpers';

const Dot = () => {
  return (
    <FiberManualRecordIcon
      fontSize='small'
      sx={{ fontSize: '6px', color: 'var(--545454)', mt: '7px' }}
    />
  );
};
const WithDot = ({ children, icon }) => {
  return (
    <Stack direction='row' gap='10px' alignItems={'start'}>
      {!icon ? <Dot /> : <div className='dot-icon'>{icon}</div>}
      <div>{children}</div>
    </Stack>
  );
};

const AssetImportInfo = ({ open, toggle, handleProceed }) => {
  return (
    <Drawer open={open} onClose={toggle} toggle={toggle} anchor='right'>
      <Wrapper maxWidth={500} px={'1rem'}>
        <div className='import_wrappper'>
          <Stack my='16px' spacing='14px'>
            <Typography bold>Import Asset List</Typography>
            <Divider />
          </Stack>

          <Stack spacing='10px'>
            <Stack spacing={'5px'}>
              <Typography bold className=''>
                Quick Guide: Importing Asset Lists
              </Typography>
              <Typography size={'xs'} light>
                This guide will walk you through importing your asset list into
                our software in just a few easy steps.
              </Typography>
            </Stack>
            <Stack>
              <Typography size='sm' bold>
                Before You Begin:
              </Typography>
              <WithDot>
                <Typography size='xs' light mt='3px'>
                  <a href={assetDoc} download>
                    Download the sample csv file:
                  </a>{' '}
                  It's crucial to use the provided sample CSV file to ensure
                  your asset list is formatted correctly for import. This will
                  help avoid errors during upload.
                </Typography>
              </WithDot>
              <Typography size='xs' mt='5px'>
                <strong>Important Note:</strong> After import, all assets will
                need to be assigned to employees manually if required.
              </Typography>
            </Stack>
            <Stack mt={'8px'} spacing='10px'>
              <Typography bold>Step By Step Guide :</Typography>
              <WithDot icon='1.'>
                <Typography bold size='sm'>
                  Asset/Vehicle Selection
                </Typography>
                <WithDot>
                  <Typography size='xs' light mt='4px'>
                    In the upload file, you'll be need to choose whether you're
                    adding an Asset or a Vehicle.
                  </Typography>
                </WithDot>
              </WithDot>
              <WithDot icon='2.'>
                <Typography bold size='sm'>
                  Asset Vehicle Status:
                </Typography>
                <Typography size='xs' light mt='4px'>
                  Next, input the appropriate category for your asset or vehicle
                  as seen on each column on the sample following the approach
                  below
                </Typography>

                {/* <WithDot icon='-'>
                  <Typography size='xs' light>
                    SUV{' '}
                  </Typography>
                </WithDot>
                <WithDot icon='-'>
                  <Typography size='xs' light>
                    Van{' '}
                  </Typography>
                </WithDot> */}
              </WithDot>
              <Typography size='xs' light>
                <strong className='mt-4 text-[#545454]'>
                  A. Asset or Vehicle (Input the category to be uploaded):
                </strong>
              </Typography>
              <div>
                <Typography size='xs' light>
                  <strong className='mt-4 text-[#545454]'>B. Type:</strong> This
                  input should be based on the categories below
                </Typography>
                <WithDot icon='-'>
                  <Typography size='xs' light>
                    Cars
                  </Typography>
                </WithDot>
                <WithDot icon='-'>
                  <Typography size='xs' light>
                    Trucks
                  </Typography>
                </WithDot>
                <WithDot icon='-'>
                  <Typography size='xs' light>
                    Buses{' '}
                  </Typography>
                </WithDot>
                <WithDot icon='-'>
                  <Typography size='xs' light>
                    Bikes{' '}
                  </Typography>
                </WithDot>
                <Typography size='xs' light>
                  <strong className='mt-4 text-[#545454]'>Assets:</strong> Any
                  Electronic devices or household appliances (Laptops,
                  Generators, Mobile Phones etc)
                </Typography>
              </div>
              <Typography size='xs' light>
                <strong className='mt-4 text-[#545454]'>C. Asset Name :</strong>{' '}
                This Sub-category name of the asset or vehicle (Sienna, Camry,
                Office chair, LaserJet etc.).
              </Typography>
              <Typography size='xs' light>
                <strong className='mt-4 text-[#545454]'>
                  D. Make or Brand :
                </strong>{' '}
                Toyota, Honda, HP, Nokia, Samsung etc
              </Typography>
              <div>
                <Typography size='xs' light>
                  <strong className='mt-4 text-[#545454]'>E. Model :</strong>{' '}
                </Typography>
                <WithDot icon='-'>
                  <Typography size='xs' light>
                    Vehicle : The year model of the vehicle (e.g 2008)
                  </Typography>
                </WithDot>
                <WithDot icon='-'>
                  <Typography size='xs' light>
                    Asset : the model of the device or gadgets (S22 for Samsung
                    phone, Latitude for Dell Laptop etc.)
                  </Typography>
                </WithDot>
              </div>
              <div>
                <Typography size='xs' light>
                  <strong className='mt-4 text-[#545454]'>
                    F. License/Serial Number :
                  </strong>{' '}
                </Typography>
                <WithDot icon='-'>
                  <Typography size='xs' light>
                    Asset: Serial Number
                  </Typography>
                </WithDot>
                <WithDot icon='-'>
                  <Typography size='xs' light>
                    Vehicle: License Number
                  </Typography>
                </WithDot>
              </div>
              <div>
                <Typography size='xs' light>
                  <strong className='mt-4 text-[#545454]'>G. Status :</strong>{' '}
                  This is the present position of the asset or vehicle
                </Typography>
                <WithDot icon='-'>
                  <Typography size='xs' light>
                    Operational
                  </Typography>
                </WithDot>
                <WithDot icon='-'>
                  <Typography size='xs' light>
                    Broken
                  </Typography>
                </WithDot>
                <WithDot icon='-'>
                  <Typography size='xs' light>
                    Missing
                  </Typography>
                </WithDot>
                <WithDot icon='-'>
                  <Typography size='xs' light>
                    Discarded
                  </Typography>
                </WithDot>
                <WithDot icon='-'>
                  <Typography size='xs' light>
                    Sold
                  </Typography>
                </WithDot>
              </div>
              <div>
                <Typography size='xs' light>
                  <strong className='mt-4 text-[#545454]'>
                    H. Purchase Condition :
                  </strong>{' '}
                  This is the position of the asset or vehicle when purchased.
                </Typography>
                <WithDot icon='-'>
                  <Typography size='xs' light>
                    Used
                  </Typography>
                </WithDot>
                <WithDot icon='-'>
                  <Typography size='xs' light>
                    New
                  </Typography>
                </WithDot>
              </div>
              <Typography size='xs' light>
                <strong className='mt-4 text-[#545454]'>J. Mileage:</strong>{' '}
                This is the present distance duration the Vehicle <br />
                had engaged NB: for assets just input 0.
              </Typography>
              <Typography size='xs' light>
                <strong className='mt-4 text-[#545454]'>
                  K. Purchase Date:
                </strong>{' '}
                Purchase Date: YYYY-MM-DD
              </Typography>
              <Typography size='xs' light>
                <strong className='mt-4 text-[#545454]'>
                  L. Purchase Cost:
                </strong>{' '}
                Enter plain values with no decimal points or commas
              </Typography>
              <WithDot icon='3.'>
                <Typography bold size='sm'>
                  Once done with the inputs, save the file as a .csv format then
                  Return to the Asset Import screen and carry out the next flow
                  to successfully import your saved file:
                </Typography>
                <WithDot icon='-'>
                  <Typography size='xs' light>
                    Click Upload File and select your completed CSV.
                  </Typography>
                </WithDot>
                <WithDot icon='-'>
                  <Typography size='xs' light>
                    Review the preview screen to check out for errors such as
                    Header mismatches, Invalid values (e.g., wrong status),
                    Missing required fields.
                  </Typography>
                </WithDot>
              </WithDot>
              <WithDot icon='4.'>
                <Typography bold size='sm'>
                  Confirm Import once validation passes.
                </Typography>
              </WithDot>
            </Stack>
          </Stack>
        </div>
        <div className='actions'>
          <CustomButton
            fullWidth
            size='xs'
            py='10px'
            variant={'contained'}
            onClick={handleProceed}
          >
            Proceed To Import
          </CustomButton>
          <CustomButton
            fullWidth
            variant={'offwhite'}
            onClick={generateCSV}
            size='xs'
            py='10px'
          >
            Download Sample Csv
          </CustomButton>
        </div>
      </Wrapper>
    </Drawer>
  );
};

export default AssetImportInfo;

const Wrapper = styled(Box)`
  position: relative;
  height: 100%;
  overflow-y: auto;
  width: 450px;

  .actions {
    position: sticky;
    bottom: 0px;
    width: 98%;
    display: flex;
    gap: 1rem;
    background-color: white;
    padding-block: 0.5rem 1rem;
  }
`;
